export default __webpack_public_path__ + "static/media/Portofolio.1c77cd30.png";